import BaseModel from '../BaseModel'

export default class UserModel extends BaseModel {
  constructor (data) {
    super(data)
  }
}



// WEBPACK FOOTER //
// ./src/api/auth/UserModel.js